import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { GoogleAdWordsObjectDataset } from 'app/model/dataset/google-adwords.dataset';
import { Metamodel } from 'app/model/base/model';
import { GoogleAdWordsLinkedService } from 'app/model/linkedservice/google-adwords.linkedservice';

export const googleAdWordsObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(GoogleAdWordsObjectDataset).name,
    displayName: stringResources.GoogleAdWords_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(GoogleAdWordsLinkedService).name],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-google_adwords'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    disableTableName: true,
    v1SupportSchema: true,
    category: ['Database'],
    queryDescription: stringResources.GoogleAdwords_Query_Description,
    skipEscapeQueryDescription: true
};
